<mat-toolbar class="toolbar" [class.black-bottom]="(title$ | async) !== null">
  <button
    mat-icon-button
    class="back-btn"
    (click)="navigationAction()"
    aria-label="navigation"
    *ngIf="showIcon$ | async"
  >
    <mat-icon>{{ icon$ | async }}</mat-icon>
  </button>
  <div class="title">{{ title$ | async }}</div>
  <img
    class="title h-5 w-5"
    *ngIf="showLogo$$.asObservable() | async"
    src="assets/images/5f-logo.svg"
    alt="lohi logo"
  />

  <span
    class="material-icons absolute cursor-pointer"
    style="right: 16px"
    *ngIf="showLogo$$.asObservable() | async"
    (click)="logout()"
    >logout</span
  >
</mat-toolbar>
